import {FinancingCompositionScene, CompositionTextLayer} from '@dms/api/shared';

import {randomLowerCaseUUID} from 'shared/web';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {createCenteredLayerBox} from './createCenteredLayerBox';

const DEFAULT_TEXT_COLOR = '#FFFFFF';
const MIN_DEFAULT_FONT_SIZE = 12;
const DEFAULT_FONT_SIZE_RATIO = 0.06;

export const createTextLayer = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>,
  text: string
): CompositionTextLayer => ({
  id: randomLowerCaseUUID(),
  type: 'text',
  ...createCenteredLayerBox(canvas, 0.5, 0.12),
  opacity: 1,
  text,
  fontId: null,
  fontSize: Math.max(MIN_DEFAULT_FONT_SIZE, Math.round(canvas.height * DEFAULT_FONT_SIZE_RATIO)),
  fontWeight: 700,
  color: DEFAULT_TEXT_COLOR,
  align: 'center',
  lineHeight: compositionEditorLimits.defaultLineHeight,
});
